import { MARGINS_BLOCKS } from '@features/cms/const';
import { TMarginsTypes } from '@features/pages/typescript';
import theme from '@styles/theme';
const getGridTemplateColumns = (itemsLength: number) => {
  const desktopColsNumber = itemsLength === 6 ? 3 : itemsLength > 5 ? 5 : itemsLength;
  const tabletColsNumber = itemsLength >= 5 ? 3 : itemsLength;
  const mobileColsNumber = itemsLength > 3 ? 3 : itemsLength;
  return [`repeat(2, 1fr)`, `repeat(${mobileColsNumber}, 1fr)`, `repeat(${tabletColsNumber}, 1fr)`, null, `repeat(${desktopColsNumber}, 1fr)`];
};
export default {
  section: (bg: string, marginTop: TMarginsTypes, marginBottom: TMarginsTypes) => ({
    mt: MARGINS_BLOCKS[marginTop],
    mb: MARGINS_BLOCKS[marginBottom],
    bg: bg || theme.rawColors.beige500,
    p: ['12.8vw 4.266667vw', '48px 16px', '8.3333333vw 3.125vw', '6.0416667vw 10.15625vw']
  }),
  description: (color: string) => ({
    display: 'block',
    maxWidth: 752,
    color
  }),
  iconContainer: (itemsLength: number) => ({
    mt: [40, 40, 80],
    display: 'grid',
    gridTemplateColumns: getGridTemplateColumns(itemsLength),
    gridRowGap: [40, 40, 80],
    gridColumnGap: [20, 20, 40],
    justifyContent: 'center',
    maxWidth: '100%',
    gridAutoFlow: 'dense'
  })
};